// Function to fetch products data

import { off } from "rsuite/esm/DOMHelper";
import { getToken } from "./authHelper";

export const fetchProducts = async () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(`${apiUrl}/admin/get_products`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    const productDetails = await data.results.product_details;
    return productDetails;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

export const fetchUsers = async (
  limit,
  offset,
  searchEmail,
  searchFirstName,
  searchLastName,
  searchPhoneNumber,
  setUsers,
  currentPage,
  orderBy,
  orderByDirection,
  partnerUsersOnly = false
) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  // The API lists either regular users or only partner embed users (e.g. HERE).
  var requestBody = { partner_users_only: partnerUsersOnly };
  if (searchEmail !== "") {
    requestBody["email"] = searchEmail;
  }
  if (searchFirstName !== "") {
    requestBody["first_name"] = searchFirstName;
  }
  if (searchLastName !== "") {
    requestBody["last_name"] = searchLastName;
  }
  if (searchPhoneNumber !== "") {
    requestBody["phone_number"] = searchPhoneNumber;
  }
  if (orderBy !== "") {
    requestBody["order_by"] = orderBy;
  }
  if (orderByDirection !== "") {
    requestBody["order_by_direction"] = orderByDirection;
  }
  const response = await fetch(
    `${apiUrl}/admin/get_users?limit=${limit}&offset=${
      (currentPage - 1) * limit
    }`,
    {
      method: "Post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(requestBody),
    }
  );
  const data = await response.json();
  setUsers(data.results);
};

export const fetchUserSubscriptions = async (
  userId,
  setUserSubscriptionIds
) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(
      `${apiUrl}/auth/get_user_subscription?user_id=${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const data = await response.json();
    const userSubscriptions = data.results;
    setUserSubscriptionIds(userSubscriptions);
  } catch (error) {
    console.error("Error fetching user subscriptions:", error);
  }
};
export const fetchAccountSubscriptions = async (
  accountId,
  setUserSubscriptionIds,
  setLoadingSubscriptions
) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(
      `${apiUrl}/account/get_account_subscriptions?account_id=${accountId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const data = await response.json();
    const userSubscriptions = data.results.subscriptions;
    setUserSubscriptionIds(userSubscriptions);
  } catch (error) {
    console.error("Error fetching user subscriptions:", error);
  } finally {
    setLoadingSubscriptions(false);
  }
};

export const fetchSubscriptions = async (setSubscriptions) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  try {
    const response = await fetch(`${apiUrl}/admin/get_subscriptions`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    setSubscriptions(data.results.subscriptions_details);
  } catch (error) {
    console.error("Error fetching subscriptions:", error);
  }
};

export const subscribeUser = async (
  subscription,
  selectedUser,
  setShowSubscribeModal
) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const data = {
    reference_id: selectedUser.id,
    reference_type: "USER_ID",
    subscription_id: subscription.id,
    details_object: {},
    start_timestamp: new Date().toISOString(),
    subscription_status: "active",
  };

  const response = await fetch(`${apiUrl}/admin/user_subscribe`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(data),
  });

  if (response.ok) {
    alert("User subscribed successfully");
    return true;
  }
  alert("Failed to subscribe user");
  return false;
};

export const subscribeAccount = async (
  subscription,
  selectedUser,
  setShowSubscribeModal
) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const data = {
    reference_id: selectedUser.id,
    reference_type: "USER_ID",
    subscription_id: subscription.id,
    details_object: {},
    start_timestamp: new Date().toISOString(),
    subscription_status: "active",
  };

  const response = await fetch(`${apiUrl}/admin/account_subscribe`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(data),
  });

  if (response.ok) {
    alert("User subscribed successfully");
    return true;
  }
  alert("Failed to subscribe user");
  return false;
};

export const fetchDashboards = async (setDashboards) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(`${apiUrl}/admin/get_dashboards`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    setDashboards(
      data.results.dashboard_details.map((dashboard) => ({
        ...dashboard,
        details_object: JSON.stringify(dashboard.details_object),
      }))
    );
  } catch (error) {
    console.error("Error fetching dashboards:", error);
  }
};

export const fetchPackages = async () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(`${apiUrl}/admin/get_packages`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    return data.results.packages_details;
  } catch (error) {
    console.error("Error fetching packages:", error);
    throw error;
  }
};

export const fetchAccounts = async (
  searchName,
  searchReferenceId,
  setAccounts,
  setLoadingAccounts
) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  var requestBody = {};
  if (searchName !== "") {
    requestBody["name"] = searchName;
  }
  if (searchReferenceId !== "") {
    requestBody["reference_id"] = searchReferenceId;
  }
  try {
    const response = await fetch(`${apiUrl}/account/search_accounts`, {
      method: "Post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(requestBody),
    });
    const data = await response.json();
    setAccounts(data.results.account_details);
  } catch (error) {
    console.error("Error fetching accounts:", error);
  } finally {
    setLoadingAccounts(false);
  }
};

export const createOrUpdateAccount = async ({
  formData,
  setLoading,
  setError,
  setSuccessMessage,
}) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  setLoading(true);

  try {
    const response = await fetch(`${apiUrl}/account/create_or_update_account`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(formData),
    });
    if (!response.ok) {
      setError(true);
    } else {
      const data = await response.json();
      setSuccessMessage(data.message);
      return data;
    }
  } catch (error) {
    console.error("Error fetching accounts:", error);
    setError(true);
  } finally {
    setLoading(false);
  }
};

export const fetchOrganizations = async ({
  setOrganizations,
  name,
  setLoading,
}) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const nameQuery = name ? "?name=" + name : "";
  setLoading(true);
  try {
    const response = await fetch(`${apiUrl}/org/search` + nameQuery, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    // The API answers 404 (no `results`) when nothing matches, including an empty table.
    setOrganizations(Array.isArray(data.results) ? data.results : []);
  } catch (error) {
    setOrganizations([]);
    console.error("Error fetching organizations:", error);
  } finally {
    setLoading(false);
  }
};

export const createOrganization = async ({ reqdata, setLoading }) => {
  setLoading(true);
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(
      `${apiUrl}/org/create_or_update_organization`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(reqdata),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating organization:", error);
    throw error;
  } finally {
    setLoading(false);
  }
};

export const createView = async ({
  setLoading,
  query,
  setSuccessMessage,
  setError,
}) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  setLoading(true);
  try {
    const response = await fetch(`${apiUrl}/admin/create_view?query=${query}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    if (!response.ok) {
      setError("Error in view creation");
    } else {
      if (!data.success) {
        setError(data.errorObject.message);
      } else {
        setSuccessMessage("View created successfully");
      }
    }
    return data;
  } catch (error) {
    console.error("Error creating view:", error);
    setError(true);
    throw error;
  } finally {
    setLoading(false);
  }
};

export const fetchViews = async ({ setViews }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(`${apiUrl}/admin/views`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    setViews(data.results);
  } catch (error) {
    console.error("Error fetching views:", error);
  }
};

export const deleteUser = async ({ id }) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  try {
    const response = await fetch(`${apiUrl}/admin/delete_user?user_id=${id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};

export const deactivateUserSubscription = async ({
  userId,
  subscriptionId,
}) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  try {
    const response = await fetch(
      `${apiUrl}/admin/deactivate_user_subscription?user_id=${userId}&subscription_id=${subscriptionId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deactivating user subscription:", error);
    throw error;
  }
};

export const deactivateAccountSubscription = async ({
  accountId,
  subscriptionId,
}) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  try {
    const response = await fetch(
      `${apiUrl}/admin/deactivate_account_subscription?account_id=${accountId}&subscription_id=${subscriptionId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deactivating account subscription:", error);
    throw error;
  }
};

export const fetchUsersForAccount = async ({ accountId }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(
      `${apiUrl}/admin/account/get_users?account_id=${accountId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const data = await response.json();
    return data.results;
  } catch (error) {
    console.error("Error fetching users for account:", error);
    throw error;
  }
};

export const addUserToAccount = async ({ accountId, userEmail }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(
      `${apiUrl}/admin/account/add_user?account_id=${accountId}&user_email=${userEmail}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding user to account:", error);
    throw error;
  }
};

export const removeUserFromAccount = async ({ accountId, userId }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(
      `${apiUrl}/admin/account/remove_user?account_id=${accountId}&user_id=${userId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error removing user from account:", error);
    throw error;
  }
};

// Partner embed API keys (emgpt /partner/keys). Errors carry the API's
// `detail` message, e.g. when the organisation has no EMBEDDED account.
const partnerKeysRequest = async (path, options = {}) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const response = await fetch(`${apiUrl}/partner/keys${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    const detail = Array.isArray(data.detail)
      ? data.detail.map((d) => d.msg).join("; ")
      : data.detail || data.errorObject?.message;
    throw new Error(detail || `Request failed (${response.status})`);
  }
  return data.results;
};

export const fetchPartnerKeys = () => partnerKeysRequest("");

// Issues the organisation's key, replacing (rotating) any existing one.
// The returned `api_key` is the only time the plaintext is available. What the
// key can open comes from the account's plans (`screens` in the response).
export const issuePartnerKey = ({ organisationId, expiresAt }) =>
  partnerKeysRequest("", {
    method: "POST",
    body: JSON.stringify({
      organisation_id: organisationId,
      expires_at: expiresAt || null,
    }),
  });

export const revokePartnerKey = (organisationId) =>
  partnerKeysRequest(`/${organisationId}`, { method: "DELETE" });
